import 'chart.js'
import moment from 'moment'
import { ResponsiveLine } from 'nivo'
import * as React from 'react';


interface IBarProps {
  tickets: any[];
  isHost: boolean;
  currency: string;
}
class DailyLineChart extends React.Component<IBarProps, { [label: string]: any }> {

  constructor(props) {
    super(props)
    this.state = {
      data: [],
      totalPrivate: 0,
      totalPublic: 0
    }
    this.formatNumber = this.formatNumber.bind(this);
  }

  public formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
  public componentWillMount() {

    const ticketMapPublic: any[] = [];
    const ticketMapPrivate: any[] = [];

    this.props.tickets.forEach((item, index) => {
      if (item.boughtAt !== undefined && item.boughtAt !== null) {
        const date = moment(item.boughtAt)
          .format("MM-DD");

        if (item.promoterId === null) {
          let element = ticketMapPrivate.find((x) => {
            return x.x === date
          })

          const duplicateElement = ticketMapPublic.find((x) => {
            return x.x === date
          })
          if (duplicateElement === undefined) {
            ticketMapPublic.push({
              x: date, y: 0
            })
          }

          if (element === undefined) {
            ticketMapPrivate.push({
              x: date, y: 0
            })
            element = ticketMapPrivate.find((x) => {
              return x.x === date
            })
          }
          if (item.status !== 'activated' && item.status !== 'cancelled' && item.status !== 'refunded') {
            const toAdd = Number(((item.totalPrice - item.totalPlatformFees - item.totalProcessingFees) / 100).toFixed(2));
            ticketMapPrivate[ticketMapPrivate.indexOf(element)] = {
              ...element,
              y: element.y + toAdd
            }
          }
        } else {
          let element = ticketMapPublic.find((x) => {
            return x.x === date
          })

          const duplicateElement = ticketMapPrivate.find((x) => {
            return x.x === date
          })
          if (duplicateElement === undefined) {
            ticketMapPrivate.push({
              x: date, y: 0
            })
          }

          if (element === undefined) {
            ticketMapPublic.push({
              x: date, y: 0
            })
            element = ticketMapPublic.find((x) => {
              return x.x === date
            })
          }

          if (item.status !== 'activated' && item.status !== 'cancelled' && item.status !== 'refunded') {
            const toAdd = Number(((item.totalPrice - item.totalPlatformFees - item.totalProcessingFees) / 100).toFixed(2));
            ticketMapPublic[ticketMapPublic.indexOf(element)] = {
              ...element,
              y: element.y + toAdd
            }
          }
        }
      }
    })

    ticketMapPrivate.sort((a, b) => {
      if (a.x < b.x) {
        return -1;
      }
      if (a.x > b.x) {
        return 1;
      }
      return 0;
    })

    ticketMapPublic.sort((a, b) => {
      if (a.x < b.x) {
        return -1;
      }
      if (a.x > b.x) {
        return 1;
      }
      return 0;
    })

    if (screen.width < 768) {
      ticketMapPublic.map((item, index) => {
        if (index % 2 === 0) {
          ticketMapPublic[index].x = ''
          for (let i = 0; i < index; i++) {
            ticketMapPublic[index].x += ' '
          }
        }
      })
      ticketMapPrivate.map((item, index) => {
        if (index % 2 === 0) {
          ticketMapPrivate[index].x = ''
          for (let i = 0; i < index; i++) {
            ticketMapPrivate[index].x += ' '
          }
        }
      })
    }

    this.setState({
      data: [
        {
          id: "Promoter Tickets ($)",
          // color: "hsl(216, 39%, 28%)",
          data: ticketMapPublic
        },
        {
          id: "General Tickets ($)",
          // color: "hsl(166, 39%, 43%)",
          data: ticketMapPrivate
        }
      ]
    })
  }

  public render() {
    return (
      <div>
        <div>
          <div style={{ textAlign: 'center', height: '400px', width: '100%' }}>
            <ResponsiveLine
              data={this.state.data}
              margin={{ top: 50, right: 5, bottom: 60, left: 50 }}
              xScale={{ type: 'point' }}
              yScale={{ type: 'linear', stacked: true, min: 'auto', max: 'auto' }}
              axisTop={null}
              colors='paired'
              axisRight={null}
              axisBottom={{
                orient: 'bottom',
                tickSize: 5,
                tickPadding: 5,
                tickRotation: -90,
                legend: 'Date',
                legendOffset: 55,
                legendPosition: 'middle'
              }}
              axisLeft={{
                orient: 'left',
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'Revenue',
                legendOffset: -40,
                legendPosition: 'middle'
              }}
              pointSize={10}
              pointColor={{ theme: 'background' }}
              pointBorderWidth={2}
              pointBorderColor={{ from: 'serieColor' }}
              pointLabel="y"
              pointLabelYOffset={-12}
              useMesh={true}
              enableCurve={true}
              curve={'catmullRom'}
              legends={[
                {
                  anchor: 'bottom-right',
                  direction: 'column',
                  justify: false,
                  translateX: 100,
                  translateY: 0,
                  itemsSpacing: 0,
                  itemDirection: 'left-to-right',
                  itemWidth: 80,
                  itemHeight: 20,
                  itemOpacity: 0.75,
                  symbolSize: 12,
                  symbolShape: 'circle',
                  symbolBorderColor: 'rgba(0, 0, 0, .5)',
                  effects: [
                    {
                      on: 'hover',
                      style: {
                        itemBackground: 'rgba(0, 0, 0, .03)',
                        itemOpacity: 1
                      }
                    }
                  ]
                }
              ]}
            />
          </div>
        </div>
        <p />
      </div>
    );
  }
}

export default DailyLineChart;



// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/DailyLineChart.tsx